import { toDate } from 'date-fns';

export const MAX_AGE = 105;
export const MIN_AGE = 18; // must be 18 or older

export function parseDate(string) {
  return toDate(string);
}

export const birthdayYearList = () => {
  const birthYears = [];
  const startYear = new Date().getFullYear() - MIN_AGE;
  const endYear = startYear - MAX_AGE;

  for (let i = startYear; i > endYear; i--) {
    birthYears.push(i);
  }

  return birthYears;
};

export const getDaysInMonth = (year, month) =>
  new Date(year, month, 0).getDate();

export const birthdayDaysList = (year, month) => {
  const daysInMonth = month ? getDaysInMonth(year, month) : 31;
  const days = [];

  for (let i = 1; i <= daysInMonth; i++) {
    days.push(i);
  }

  return days;
};
